import { all, takeLatest, fork, put, select } from 'redux-saga/effects';
import UIHelper from 'services/UIHelper';
import routeCodes from 'common/constants/route-codes';
import DishOptionsApi from 'libs/api/dish_options';
import * as types from './types';
import { setModalData } from '../common/actions';


function* getDishOptions({ payload }) {
  try {
    const currentRestaurant = yield select(
      (state) => state.common.currentRestaurant,
    );
    const api = new DishOptionsApi(currentRestaurant?.id);

    const { data } = yield api.list({
      params: {
        per: 10000,
      }
    });
    yield put({
      type: types.DISH_OPTIONS_CATEGORY_GET_SUCCESS,
      payload: data.options,
    });
  } catch (e) {
    yield put({
      type: types.DISH_OPTIONS_CATEGORY_GET_FAILURE,
      payload: e?.response?.data,
    });
  }
}

function* createOrUpdate({ payload }) {
  try {
    const { id, data, history } = payload;
    const currentRestaurant = yield select(
      (state) => state.common.currentRestaurant,
    );
    const api = new DishOptionsApi(currentRestaurant?.id);
    const response = id
      ? yield api.put(id, { data })
      : yield api.create({
        data,
      });
    yield put({
      type: types.DISH_OPTIONS_CATEGORY_CREATE_OR_UPDATE_SUCCESS,
    });
    yield put({
      type: types.DISH_OPTIONS_CATEGORY_GET_REQUEST,
    });
    UIHelper.showCreateOrUpdateSuccess();
    history?.push(routeCodes.menu);
  } catch (e) {
    yield put({
      type: types.DISH_OPTIONS_CATEGORY_CREATE_OR_UPDATE_FAILURE,
      payload: e?.response?.data,
    });
  }
}

function* deleteOption({ payload }) {
  try {
    const { history, id } = payload;
    const currentRestaurant = yield select(
      (state) => state.common.currentRestaurant,
    );
    const api = new DishOptionsApi(currentRestaurant?.id);
    yield api.destroy(id);
    yield put({
      type: types.DISH_OPTIONS_CATEGORY_GET_REQUEST,
    });
    // TODO need text for notification
    yield put(
      setModalData({
        open: false,
        variant: 'primary',
        title: '',
        body: '',
        itemData: {},
      }),
    );
    history?.push(routeCodes.menu);
  } catch (e) {
    yield put({
      type: types.DISH_OPTIONS_CATEGORY_DELETE_REQUEST,
    });
  }
}

function* watchGetDishOptions() {
  yield takeLatest(types.DISH_OPTIONS_CATEGORY_GET_REQUEST, getDishOptions);
}

function* watchCreateOrUpdateDishOptions() {
  yield takeLatest(types.DISH_OPTIONS_CATEGORY_CREATE_OR_UPDATE_REQUEST, createOrUpdate);
}

function* watchDeleteOption() {
  yield takeLatest(types.DISH_OPTIONS_CATEGORY_DELETE_REQUEST, deleteOption);
}

export default function* dishOptionsSaga() {
  yield all([fork(watchGetDishOptions), fork(watchCreateOrUpdateDishOptions), fork(watchDeleteOption)]);
}
